// origin values
export const APP_ORIGIN_D2D = 'd2d';
export const ALLOWED_ORIGIN_VALUES = [
  'dl',
  'el',
  'qr',
  'sms',
  'dl_iva',
  'sms_iva',
  'dl_wks',
  'sms_wks',
];
